"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get getToolDir () {
        return getToolDir;
    },
    get jdbcToXcConfig () {
        return jdbcToXcConfig;
    },
    get jdbcToXcUrl () {
        return jdbcToXcUrl;
    },
    get metaUrlToDbConfig () {
        return metaUrlToDbConfig;
    },
    get prepareEnv () {
        return prepareEnv;
    },
    get xcUrlToDbConfig () {
        return xcUrlToDbConfig;
    }
});
const _fs = /*#__PURE__*/ _interop_require_default(require("fs"));
const _url = require("url");
const _util = require("util");
const _parsedatabaseurl = /*#__PURE__*/ _interop_require_default(require("parse-database-url"));
const _constants = require("./constants");
const _interfaces = require("./interfaces");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
    }
    return target;
}
async function prepareEnv({ databaseUrlFile = process.env.NC_DATABASE_URL_FILE || process.env.DATABASE_URL_FILE, databaseUrl = process.env.NC_DATABASE_URL || process.env.DATABASE_URL } = {}) {
    if (databaseUrlFile) {
        const database_url = await (0, _util.promisify)(_fs.default.readFile)(databaseUrlFile, 'utf-8');
        process.env.NC_DB = jdbcToXcUrl(database_url);
    } else if (databaseUrl) {
        process.env.NC_DB = jdbcToXcUrl(databaseUrl);
    }
}
function getToolDir() {
    return process.env.NC_TOOL_DIR || process.cwd();
}
function jdbcToXcConfig(url) {
    // drop the jdbc prefix
    url.replace(/^jdbc:/, '');
    const config = (0, _parsedatabaseurl.default)(url);
    const parsedConfig = {};
    for (const [key, value] of Object.entries(config)){
        const fnd = _constants.knownQueryParams.find((param)=>param.parameter === key || param.aliases.includes(key));
        if (fnd) {
            parsedConfig[fnd.parameter] = value;
        } else {
            parsedConfig[key] = value;
        }
    }
    if (!(parsedConfig == null ? void 0 : parsedConfig.port)) {
        parsedConfig.port = _constants.defaultClientPortMapping[_constants.driverClientMapping[parsedConfig.driver] || parsedConfig.driver];
    }
    const { driver } = parsedConfig, connectionConfig = _object_without_properties_loose(parsedConfig, [
        "driver"
    ]);
    const client = _constants.driverClientMapping[driver] || driver;
    if (client === 'pg' && !(connectionConfig == null ? void 0 : connectionConfig.ssl) && !_constants.avoidSSL.includes(connectionConfig.host)) {
        connectionConfig.ssl = true;
    }
    return {
        client: client,
        connection: _extends({}, connectionConfig)
    };
}
function jdbcToXcUrl(url) {
    // drop the jdbc prefix
    url.replace(/^jdbc:/, '');
    const config = (0, _parsedatabaseurl.default)(url);
    const parsedConfig = {};
    for (const [key, value] of Object.entries(config)){
        const fnd = _constants.knownQueryParams.find((param)=>param.parameter === key || param.aliases.includes(key));
        if (fnd) {
            parsedConfig[fnd.parameter] = value;
        } else {
            parsedConfig[key] = value;
        }
    }
    if (!(parsedConfig == null ? void 0 : parsedConfig.port)) {
        parsedConfig.port = _constants.defaultClientPortMapping[_constants.driverClientMapping[parsedConfig.driver] || parsedConfig.driver];
    }
    const { driver, host, port, database, user, password } = parsedConfig, extra = _object_without_properties_loose(parsedConfig, [
        "driver",
        "host",
        "port",
        "database",
        "user",
        "password"
    ]);
    const extraParams = [];
    for (const [key, value] of Object.entries(extra)){
        extraParams.push(`${key}=${encodeURIComponent(value + '')}`);
    }
    const res = `${_constants.driverClientMapping[driver] || driver}://${host}${port ? `:${port}` : ''}?${user ? `u=${encodeURIComponent(user)}&` : ''}${password ? `p=${encodeURIComponent(password)}&` : ''}${database ? `d=${encodeURIComponent(database)}&` : ''}${extraParams.join('&')}`;
    return res;
}
function xcUrlToDbConfig(urlString, key = '', type) {
    const url = new _url.URL(urlString);
    let dbConfig;
    if (url.protocol.startsWith('sqlite3')) {
        dbConfig = {
            client: 'sqlite3',
            connection: {
                client: 'sqlite3',
                connection: {
                    filename: url.searchParams.get('d') || url.searchParams.get('database')
                },
                database: url.searchParams.get('d') || url.searchParams.get('database')
            }
        };
    } else {
        const parsedQuery = {};
        for (const [key, value] of url.searchParams.entries()){
            const fnd = _constants.knownQueryParams.find((param)=>param.parameter === key || param.aliases.includes(key));
            if (fnd) {
                parsedQuery[fnd.parameter] = value;
            } else {
                parsedQuery[key] = value;
            }
        }
        dbConfig = {
            client: url.protocol.replace(':', ''),
            connection: _extends({}, parsedQuery, {
                host: url.hostname,
                port: +url.port
            }),
            acquireConnectionTimeout: 600000
        };
        if (process.env.NODE_TLS_REJECT_UNAUTHORIZED) {
            dbConfig.connection.ssl = true;
        }
        if (url.searchParams.get('keyFilePath') && url.searchParams.get('certFilePath') && url.searchParams.get('caFilePath')) {
            dbConfig.connection.ssl = {
                keyFilePath: url.searchParams.get('keyFilePath'),
                certFilePath: url.searchParams.get('certFilePath'),
                caFilePath: url.searchParams.get('caFilePath')
            };
        }
    }
    /* TODO check if this is needed
    if (config && !config.title) {
      config.title =
        url.searchParams.get('t') ||
        url.searchParams.get('title') ||
        this.generateRandomTitle();
    }
  */ Object.assign(dbConfig, {
        meta: {
            tn: 'nc_evolutions',
            allSchemas: !!url.searchParams.get('allSchemas') || !(url.searchParams.get('d') || url.searchParams.get('database')),
            api: {
                prefix: url.searchParams.get('apiPrefix') || '',
                swagger: true,
                type: type || url.searchParams.get('api') || url.searchParams.get('a') || 'rest'
            },
            dbAlias: url.searchParams.get('dbAlias') || `db${key}`,
            metaTables: 'db',
            migrations: {
                disabled: false,
                name: 'nc_evolutions'
            }
        }
    });
    return dbConfig;
}
async function metaUrlToDbConfig(urlString) {
    var _dbConfig_connection, _dbConfig_connection1;
    const url = new _url.URL(urlString);
    let dbConfig;
    if (url.protocol.startsWith('sqlite3')) {
        const db = url.searchParams.get('d') || url.searchParams.get('database');
        dbConfig = _extends({
            client: _interfaces.DriverClient.SQLITE,
            connection: {
                filename: db
            }
        }, db === ':memory:' ? {
            pool: {
                min: 1,
                max: 1,
                // disposeTimeout: 360000*1000,
                idleTimeoutMillis: 360000 * 1000
            }
        } : {});
    } else {
        const parsedQuery = {};
        for (const [key, value] of url.searchParams.entries()){
            const fnd = _constants.knownQueryParams.find((param)=>param.parameter === key || param.aliases.includes(key));
            if (fnd) {
                parsedQuery[fnd.parameter] = value;
            } else {
                parsedQuery[key] = value;
            }
        }
        dbConfig = _extends({
            client: url.protocol.replace(':', ''),
            connection: _extends({}, _constants.defaultConnectionConfig, parsedQuery, {
                host: url.hostname,
                port: +url.port
            }),
            acquireConnectionTimeout: 600000
        }, _constants.defaultConnectionOptions, url.searchParams.has('search_path') ? {
            searchPath: url.searchParams.get('search_path').split(',')
        } : {});
        if (process.env.NODE_TLS_REJECT_UNAUTHORIZED) {
            dbConfig.connection.ssl = true;
        }
    }
    url.searchParams.forEach((_value, key)=>{
        let value = _value;
        if (value === 'true') {
            value = true;
        } else if (value === 'false') {
            value = false;
        } else if (/^\d+$/.test(value)) {
            value = +value;
        }
        // todo: implement config read from JSON file or JSON env val read
        if (![
            'password',
            'p',
            'database',
            'd',
            'user',
            'u',
            'search_path'
        ].includes(key)) {
            key.split('.').reduce((obj, k, i, arr)=>{
                return obj[k] = i === arr.length - 1 ? value : obj[k] || {};
            }, dbConfig);
        }
    });
    if ((dbConfig == null ? void 0 : (_dbConfig_connection = dbConfig.connection) == null ? void 0 : _dbConfig_connection.ssl) && typeof (dbConfig == null ? void 0 : (_dbConfig_connection1 = dbConfig.connection) == null ? void 0 : _dbConfig_connection1.ssl) === 'object') {
        if (dbConfig.connection.ssl.caFilePath && !dbConfig.connection.ssl.ca) {
            dbConfig.connection.ssl.ca = (await (0, _util.promisify)(_fs.default.readFile)(dbConfig.connection.ssl.caFilePath)).toString();
            delete dbConfig.connection.ssl.caFilePath;
        }
        if (dbConfig.connection.ssl.keyFilePath && !dbConfig.connection.ssl.key) {
            dbConfig.connection.ssl.key = (await (0, _util.promisify)(_fs.default.readFile)(dbConfig.connection.ssl.keyFilePath)).toString();
            delete dbConfig.connection.ssl.keyFilePath;
        }
        if (dbConfig.connection.ssl.certFilePath && !dbConfig.connection.ssl.cert) {
            dbConfig.connection.ssl.cert = (await (0, _util.promisify)(_fs.default.readFile)(dbConfig.connection.ssl.certFilePath)).toString();
            delete dbConfig.connection.ssl.certFilePath;
        }
    }
    return dbConfig;
}
